export default [

	{
		text: `
			<div class="title">Танк</div>
			<div class="text">
				В самой первой серии «Ходячих мертвецов» фигурировал танк «Чифтен», в котором Рик Граймс спрятался от орды зомби. По следам на асфальте и пятнам крови было очевидно, что он использовался военными против ходячих мертвецов: причем в дело шли не только танковые пулеметы, но и снаряды. Увы, безрезультатно. Еще один танк (М60) фигурировал в середине четвертого сезона, когда Губернатор штурмовал тюрьму, в которой укрылась группа выживших Рика. Боевая машина отлично показала себя в действии. Однако на этот раз — против живых людей.
			</div>
		`
	},
	{
		text: `
			<div class="title">Револьвер Рика Граймса</div>
			<div class="text">
				Кольт «Питон» — неизменное оружие Рика Граймса, с которым он не расстается с первого сезона (и которое использовал еще до зомби-апокалипсиса, когда работал помощником шерифа). Это шестизарядный револьвер калибра .357 Magnum. Из плюсов: плавный спусковой крючок и высокая точность попадания в голову. Из минусов: слишком тяжелый и слишком шумный.
			</div>
		`
	},
	{
		text: `
			<div class="title">Арбалет Дэрила Диксона</div>
			<div class="text">
				Фактически их у него было два. Первым — Horton Scout HD 12 — Дэрил пользовался с первого по третий сезон. Этот арбалет весит немного, значительно превосходит лук по точности и дальнобойности, а огнестрельное оружие — по уровню производимого шума. К тому же хорошо смотрится в кадре (с ростом популярности сериала цена на него значительно подскочила в реальном мире). Второй арбалет — Stryker Strykezone 380, Дэрилу привезли Рик и Мишонн из арсенала Моргана. Этот арбалет намного тяжелее, но вместе с тем и намного мощнее — настоящий кошмар для ходячих.
			</div>
		`
	},
	{
		text: `
			<div class="title">Катана Мишонн</div>
			<div class="text">
				Катана — длинная японская сабля (не стоит ее путать с коротким мечом сето). У нее изогнутое тонкое лезвие с односторонней заточкой, овальная гарда и двуручная рукоятка. Были дни, когда Мишонн только и занималась тем, что с утра до вечера рубила головы зомби, поэтому она крайне эффектно управляется с этим оружием самураев. Плюсы: можно срубить сразу три головы зомби одним ударом. Минусы: катана иногда застревает в телах мертвецов.
			</div>
		`
	},
	{
		text: `
			<div class="title">Нож-кастет, револьвер и винтовка Кэрол Пелетье</div>
			<div class="text">
				Кэрол пару сезонов вообще не брала в руки оружие, но затем как-то стремительно овладела сразу тремя его видами. В ближнем бою она смертельно опасна с ножом-кастетом, в дальнем — с миниатюрным (его легко спрятать под одеждой) револьвером Colt Detective Special и винтовкой M16A4, состоящей на вооружении у американских морпехов. Кроме того, Кэрол один раз воспользовалась взрывчаткой и огнеметом. Мертвецы были весьма шокированы своими потерями.
			</div>
		`
	},
	{
		text: `
			<div class="title">Молоток Тайриза Уильямса</div>
			<div class="text">
				Здоровый, как скала, Тайриз, не мудрствуя лукаво, пускал в ход обычный молоток. В его руках этот бытовой прибор превращался в смертельное оружие: бесшумное и верное. Единственный минус: молоток бывает тяжело достать из пробитой черепушки.
			</div>
		`
	},
	{
		text: `
			<div class="title">Палка Моргана Джонса</div>
			<div class="text">
				Деревянная палка, которую использует Морган, называется <a href="https://ru.wikipedia.org/wiki/Бо" target="_blank">бо (посох)</a> и используется в японском боевом искусстве бодзюцу. С виду это обычный посох, но в руках настоящего бойца он может превратиться в универсальное оружие. Его можно увидеть во многих фильмах о восточных единоборствах, им увлекался, в частности, Брюс Ли. Главный минус: это оружие крайне сложно освоить за короткое время. Поэтому если на вас идет зомби, то лучше взять пистолет, а с бо тренироваться в свободное от нападений время.
			</div>
		`
	},
	{
		text: `
			<div class="title">Взрывчатка</div>
			<div class="text">
				Проверенный и надежный способ по уничтожению и обезвреживанию ходячих мертвецов. В ход идут обычные, светошумовые и дымовые гранаты, шведский одноразовый ручной противотанковый гранатомет M136 AT4 и многоцелевой гранатомет DefTech 37mm Rotary Launcher, который может похвастаться большой огневой мощью.
			</div>
		`
	},
	{
		text: `
			<div class="title">Натянутая проволока</div>
			<div class="text">
				Еще один отличный способ для массовой зачистки дорожного участка от зомби придумали главные герои при помощи проволоки. Для сногсшибательной поездки необходимо натянуть крепкую струну между двумя мчащимися автомобилями на уровне глаз — головы зомби сами будут эффектно слетать с плеч, встречаясь на ходу с тонкой проволокой. Минусы: для вождения автомобиля нужны права.
			</div>
		`
	},
	{
		text: `
			<div class="title">Бита Нигана</div>
			<div class="text">
				Свою обмотанную колючей проволокой бейсбольную биту Ниган ласково называет Люсиль (пока не очень понятно в честь кого). Она одинаково эффективна как против людей, так и против зомби. Обычно Ниган разбивает ею головы. Среди поклонников сериала ее копии уже разошлись на сувениры. Из плюсов: большая убойная сила в опытных руках. Минусы: все-таки она деревянная и легко может сломаться или сгореть.
			</div>
		`
	},

]



// WEBPACK FOOTER //
// ./src/data/slider5.js